<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_170">
      <el-select
        class="select_btn_style"
        v-model="filters.isAllGraduation"
        placeholder="是否全部学员已结业"
      >
        <el-option
          v-for="(item, i) in publicData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.classLevel"
        placeholder="办班级别"
      >
        <el-option
          v-for="(item, i) in classTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.classStatus"
        placeholder="班级状态"
      >
        <el-option
          v-for="(item, i) in classStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-date-picker
        class="select_btn_style"
        v-model="filters.classYear"
        :editable="false"
        type="year"
        value-format="yyyy"
        :picker-options="pickerOptions1"
        placeholder="年份">
      </el-date-picker>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.className"
        placeholder="班级名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      classTypeData: [],
      trainTypeData: [],
      classStatusData: [],
      classPushStatusData: [],
      publicData: [],
      pickerOptions1: {
        disabledDate: (time) => {
          let minDate = new Date('2000-01-01 00:00:00');
          return time.getTime() > Date.now() ||  time.getTime() < minDate.getTime();
        },
      },
    };
  },
  created() {
    this.getSysParamByTypes(["CLASS_LEVEL_TYPE", "CLASS_TYPE_UP", "CLASS_STATUS", "CLASS_PUSH_STATUS", "IS_VALID"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["CLASS_LEVEL_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["CLASS_TYPE_UP"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["CLASS_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["CLASS_PUSH_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["IS_VALID"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.classTypeData = res.data["CLASS_LEVEL_TYPE"];
        this.trainTypeData = res.data["CLASS_TYPE_UP"];
        this.classStatusData = res.data["CLASS_STATUS"];
        this.classPushStatusData = res.data["CLASS_PUSH_STATUS"];
        this.publicData = res.data["IS_VALID"];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
.width-adapt {
  width: 135px;
}
/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 120px;
}
</style>
